import { render } from "./Professionals.vue?vue&type=template&id=63b39740"
import script from "./Professionals.vue?vue&type=script&lang=js"
export * from "./Professionals.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__